module.exports = __webpack_public_path__ + "static/media/calm-waters.2e573437.jpg";